<style scoped lang="scss">
    .modal-box {
        background-color: #fff;
    }
</style>
<template>
    <dialog ref="HTMLDialogElement" id="ogloba-vocher-status-modal" class="modal modal-middle sm:modal-middle">
        <div class="modal-box" > 
            <table class="min-w-full mt-5">
                <tbody>
                <tr v-for="voucher in responseOrderStatus">
                    <td class=" border-b border-gray-200">
                        <strong>Voucher No: {{ voucher.orderNo }}</strong>
                        <br>
                        <strong>Statut: {{ getLabelOrderStatus(voucher.orderStatus) }}</strong>
                        <pre>{{ voucher }}</pre></td>
                </tr>
                </tbody>
            </table>
            <button type="button" class="btn closeModalDialog text-white" @click="closeModalDialog()">Fermer</button>
        </div>
    </dialog>
</template>

<script lang="ts" setup>
import {ref, onMounted, toRef, watch} from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";

const modalHTMLElement = ref();
const selectedUser = ref<string | null>(null);
const props = defineProps({
    voucherRefs: {
        required: false,
        default: [],
    },
    orderSupplierId: {
        required: false,
        default: '',
    }
});
let voucherRefs = toRef(props, "voucherRefs");
let responseOrderStatus = ref([]);

const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.attributeName === "open" && modalHTMLElement.value) {
            const isOpen = modalHTMLElement.value.open;
            const isclosed = !isOpen;
            if (isclosed) {
                selectedUser.value = null;
            }
            break; 
        }
    }
});

onMounted(() => {
    
    modalHTMLElement.value = document.querySelector(
        `#ogloba-vocher-status-modal`
    );
    if (modalHTMLElement.value) {
        observer.observe(modalHTMLElement.value, { attributes: true });

    }
});


watch(
    voucherRefs,
    (value) => {
        responseOrderStatus.value=[];
        getOrderStatus(value);
        
    })


async function getOrderStatus(
    voucherRefs
) {
    const params = {
        voucherRefs: voucherRefs,
    }
    try {
        const { data } = await ApiService.post('admin/status-ogloba-product',params );
        responseOrderStatus.value = data.data.responseOrderStatus;
        
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
}

function getLabelOrderStatus(status) {
    switch (status) {
        case '03':
            return 'Pas encore confirmée.';
        case '042':
            return 'Confirmée, la carte est prête';
        case '043':
            return 'confirmée, la carte pas encore prête';
        default:
            return '';
    }
}
const closeModalDialog = () => {
    if (modalHTMLElement.value) {
        modalHTMLElement.value.close();
    }
};
</script>